module.exports = __webpack_public_path__ + "img/7.c644f094.png";